module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-app-polyfill/node_modules/core-js/internals/hidden-keys.js
// module id = 72
// module chunks = 0 1